<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-16">
        <h4 class="mt-3 mb-4">Netto-Brutto-Rechner (Umsatzsteuerrechner)</h4>

      </div>
    </div>

    <div class="row">
      <div :class="calcValues.gross.isResult ? 'col-xl-6 col-lg-7' : 'col-16'">
      
        <div class="row mt-3">
          <div class="col-16">
            
            <label class="form-label">Betrag netto (ohne Mehrwertsteuer)</label>


            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatNet" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.net.suffix"></span>
            </div>
            

            <label class="form-label">Mehrwertsteuer-Satz</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatTaxPercent" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.taxPercent.suffix"></span>
            </div>
          
            
          </div>

        </div>
      </div>
      <div class="col-xl-9 offset-xl-1 col-lg-8  mt-3" v-if="calcValues.gross.isResult">
        <h5>Ergebnis</h5>
        <p>Der Brutto-Betrag beträgt: <span class="sb-bold">{{ calcValues.gross.formatted }} <span v-html="calcValues.gross.suffix"></span></span>.</p>
        <p>Die Umsatzsteuer beträgt: <span class="sb-bold">{{ calcValues.tax.formatted }} <span v-html="calcValues.tax.suffix"></span></span>.</p>

        <apex-chart width="100%" height="400" :options="chartoptions" :series="getChartData"></apex-chart>

      </div>
    </div>

 </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "net2Gross",
  components: {
    'apexChart': VueApexCharts,
  },
  data() {
    return {
      chartoptions: {},
      calcValues: {
        gross: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        net: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        tax: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
        },
        taxPercent: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
        },
      }

    }
  },
  mounted() {
    this.chartoptions = {...this.$chartconfig.chartOptionsColumn, ...{
      colors: ['#52388E', '#AD0267', '#BFBFBF'],
      xaxis: {
          categories: ['Netto-Brutto-Rechner'],
      },
      tooltip: {
        y: {
          formatter:  (val) => {
            return `${this.$utils.beautifier(val)} €`;
         }
        }
      },
      dataLabels: {
        enabled: true,
        formatter:  (val) => {
            return `${this.$utils.beautifier(val)} €`;
         },
         offsetY: -20,
         style: {
            colors: ["#250719"]
        }
      }
    }}
    
  },
  computed: {
    formatNet: {
      get () {
        return this.getObj('net').number;
      },
      set (value) {
        return this.setObj('net', value, 1);
      }
    },
    formatTaxPercent: {
      get () {
        return this.getObj('taxPercent').number;
      },
      set (value) {
        return this.setObj('taxPercent', value, 1);
      }
    },
    getChartData () {
      return [{
          name: 'Netto-Betrag',
          data: [this.getObj('net').number]
        },
        {
          name: 'Brutto-Betrag',
          data: [this.calcValues.gross.number]
        },
        {
          name: 'Mwst.',
          data: [this.calcValues.tax.number]
        }]
    }
  },
  methods: {
    setResult(name, result) {
      let obj = this.getObj(name);
      obj.isResult = result;
      this.calcValues[name] = obj;
    },
    setObj(name, value, calcResult) {
      let obj = this.getObj(name);
      obj.number = this.$utils.formatStr2Number(value);
      obj.formatted = this.$utils.beautifier(obj.number, "de-DE", 2);
      //console.log(obj.number, obj.formatted);
      this.calcValues[name] = obj;

      if (calcResult) this.calcResult();

      return obj.number;
    },
    setObjContent(name, obj, calcResult) {
      this.calcValues[name] = obj;
      this.setObj(name, obj.number, calcResult);
    },
    getObj(name) {
      return this.calcValues[name];
    },
    calcResult() {

      let gross = this.calcValues.gross;
      let net = this.calcValues.net;
      let taxPercent = this.calcValues.taxPercent;
      let tax = this.calcValues.tax;

      //Formel: (net / 100 * taxPercent) + net

      if (taxPercent.number == 0) {

        gross.number = net.number;
        gross.isResult = true;
        this.setObjContent('gross',  gross, 0);

        tax.number = 0;
        tax.isResult = true;
        this.setObjContent('tax',  tax, 0);

      } else {

        gross.number = (net.number / 100 * taxPercent.number) + net.number;
        gross.isResult = true;
        this.setObjContent('gross',  gross, 0);

        tax.number = gross.number - net.number;
        tax.isResult = true;
        this.setObjContent('tax',  tax, 0);

      }

    }
  }
}
</script>

<style scoped>

</style>